<!-- Need to determine if the page is on a Mobile screen or not. There are various changes for Mobile, Logged In and Logged Out user -->
<template>
  <!-- First Panel (In Mobile, we have 2 panels)-->
  <div v-if="isMobile" class="introduction-container-mobile"><img src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/mobile_banner.png?v=1697649852" /></div>

  <div class="introduction-container">
    <div
    class="hero-container"
    :style="$variable('customer.loggedIn') && isMobile ? {'background-color':'#F8F4EC'} : {}"
    >
      <span
      v-if="$variable('customer.loggedIn') || !isMobile"
      class="hero-subtitle">
        {{ liquid.desktop_badge_description }}
      </span>
      <HighlighterTitle
        v-if="isMobile"
        :classes="`section-title`"
        :highlighter-copy="$variable('customer.loggedIn') ? `Hi ${$variable('customer.firstName')}, here’s how many points you have` : liquid.mobile_title"
        :style="$variable('customer.loggedIn') ? {'margin-top':'0px'} : {}"
      />
      <HighlighterTitle
        v-if="!isMobile"
        :classes="`h1 introduction-container__title--desktop`"
        :highlighter-copy="$variable('customer.loggedIn') ? `Hi ${$variable('customer.firstName')}, here’s how many points you have` : liquid.desktop_title"
        :highlighter-size="`h1`"
        :highlighter-color="`accent03`"
      />
      <div v-if="$variable('customer.loggedIn')" class="customer-info">
        <div class="customer-info__tier-container">
          <img src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/notebook.png?v=1696617719" alt="green notebook" />
          <div class="customer-info__tier-container__subtitle" >You’re on the Dean’s List:</div>
          <div class="customer-info__tier-container__title" >{{ tierName }}</div>
        </div>
        <div class="customer-info__points-container">
          <div class="customer-info__points-container__subtitle" >Your points</div>
          <div class="customer-info__points-container__title" >You have {{ customerPoints }} points</div>
        </div>
      </div>
      <span v-if="!$variable('customer.loggedIn') && liquid.desktop_subtitle"
        class="hero-description"
        v-html="$cleanRTE(liquid.desktop_subtitle, { useTextLink: true })"
       />

      <div
        class="btn-container"
        @click="saveLocalStorageVariable">
        <Btn
          v-for="cta in liquid.ctas"
          :key="cta.id"
          v-if="(logged_in && $variable('customer.loggedIn')) ||
          (!logged_in && !$variable('customer.loggedIn'))"
          :modifiers="[cta.style]"
          :url="cta.url"
          :label="cta.label"
          :custom-element="'a'"
        />
      </div>
    </div>
  </div>


</template>

<script>

import { mapState, mapActions } from 'vuex'
import HighlighterTitle from '~global/highlighter-title/highlighter-title'
import Btn from '~global/btn/btn'

export default {
  name: 'LoyaltyLion',
  components: {
    HighlighterTitle,
    Btn
  },

  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
    liquid: {
      type: Object,
      default: () => ({
        desktop_badge_description: '',
        desktop_title: '',
        desktop_subtitle: '',
        mobile_title: '',
        mobile_subtitle: '',
        ctas: []
      }),
    },
  },

  data() {
    return {
      tierName: '',
      customerPoints: loyaltylion.customer?.pointsTotal || 0,
      isPinterestCompleted: false,
      isTiktokCompleted: false,
      birthdayText: 'Celebrate',
      claimedRewards: [],
    }
  },

  computed: {

    /**
     * Map Vuex state.
    */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

  },

  mounted() {

    const cameFromLoyalty = localStorage.getItem('cameFromLoyalty');

    if(cameFromLoyalty !== null){
      localStorage.removeItem('cameFromLoyalty')
    }

    this.setComponentState({ handle: 'loyalty-lion-hero', state: 'active' })

    // Here we will get the data of the client, also check if the page is on a Mobile screen or not
    // When using these variables in the HTML over the <script> part (within Vue component, not the liquid file), we use them without the prefix "this."
    console.log('customer', this.$variable('customer'));
    console.log('customer.loggedIn', this.$variable('customer.loggedIn')); // v-if="$variable('customer.loggedIn') && !isMobile"
    console.log('customer.firstName', this.$variable('customer.firstName')); // gets the first name
    // This will let you know if it's mobile, or not
    // Comments can be deleted as you see fit
    console.log('isMobile?', this.isMobile);

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const navElement = document.getElementById("shopify-section-site-header");
          const navbarHeight = navElement.getBoundingClientRect().height;
          const offset = targetElement.getBoundingClientRect().top - navbarHeight;

          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          window.scrollTo({
            top: offset + scrollTop,
            behavior: 'smooth'
          });
        }
      });
    });

    // Amount of Points
    // The Tier the Customer is in
    if(!this.customer) return; // There is no customer

    const tier = this.customer.find(t => t.includes('tier'));
    this.tierName = tier ? tier.split('tier: ')[1] : 'Honor Roll';

    // These are the Tier Name and the Customer Points
    console.log('Tier name is:', this.tierName);

    // Observer for Rewards Summary modal
    const observer = new MutationObserver((mutationList, observer)=>{
      this.updatePoints();
      setTimeout(()=>{
        const rewardsSummary = document.getElementsByClassName('lion-redeem-reward-modal__summary')[0];
        if(rewardsSummary){
          rewardsSummary.innerText = rewardsSummary.innerText.replace('All your rewards can be viewed anytime on this page.','You can use this at checkout on your next Dormify Purchase!');
        }

        const leaveAReviewText = document.getElementsByClassName('lion-action-modal__description')[0];
        if(leaveAReviewText && leaveAReviewText.innerText.includes('Automatically')){
          leaveAReviewText.innerText = leaveAReviewText.innerText.replace('Automatically get 250 points when you leave us a review!','Get 250 points when you leave us a product review after your purchase');
        }
      }, 30)
    })

    const rulesObserver = new MutationObserver((mutations, observer)=>{
      this.updatePoints();
      setTimeout(()=>{
        this.getRulesElements();
      },250)
    })

    const config = { attributes: true, childList: true, subtree: true };

    let count = 0;
    const intervalId = setInterval(()=>{
      const loyaltyPanel = document.getElementById('loyaltylion');
      if(loyaltyPanel && loyaltylion.customer){

        this.getRulesElements();

        const loyaltyPanel = document.getElementById('loyaltylion');
        const loyaltyModalPanel = document.getElementById('lion-loyalty-panel-custom-css');
        const rulesPanel = document.getElementsByClassName('lion-rules-list')[0];
        if(loyaltyPanel){
          observer.observe(loyaltyPanel, config);
          observer.observe(loyaltyModalPanel, config);
          rulesObserver.observe(rulesPanel, config);
        }

        this.customerPoints = loyaltylion.customer.pointsTotal;
        this.claimedRewards = loyaltylion.customer.claimedRewards.filter(r => r.state === 'approved' && r.redeemable?.used_at === null);

        clearInterval(intervalId);
      }else{
        count = count+1;
      }
      if(count > 50){
        clearInterval(intervalId);
      }
    },250)
  },

  methods: {

    /**
     * Map Vuex actions.
    */
    ...mapActions({
      setComponentState: 'components/setState',
    }),

    saveLocalStorageVariable(){
      localStorage.setItem('cameFromLoyalty', true);
    },

    lionRuleItemClick(keyWordTitle){
      this.customActionsPerKeyworkTitle(keyWordTitle);
      const container = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                      .find(o=>o.innerText.includes(keyWordTitle))?.nextSibling?.nextSibling;
      console.log("container is: ", container)
      const element = container.getElementsByClassName("lion-action-button")?.[0];
      console.log("element is: ", element)
      element.click()
    },

    voucherClick(voucherTitle){
      const element = Array.from(document.getElementsByClassName('lion-reward-item__title'))
      .find(o=>o.innerText.includes(voucherTitle)).nextSibling.nextSibling.nextSibling.children[0];
      element.click();
      updatePoints();
    },

    getRulesElements(){
      const pinterestElement = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                      .find(o=>o.innerText.includes('Pinterest'))?.nextSibling?.nextSibling?.children[0];

      const tiktokElement = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                    .find(o=>o.innerText.includes('TikTok'))?.nextSibling?.nextSibling?.children[0];

      const birthdayElement = Array.from(document.getElementsByClassName('lion-rule-item__title'))
                                   .find(o=>o.innerText.includes('Birthday'))?.nextSibling?.nextSibling?.children[0];

      if(pinterestElement && pinterestElement.innerText === 'Completed') this.isPinterestCompleted = true;
      if(tiktokElement && tiktokElement.innerText === 'Completed') this.isTiktokCompleted = true;
      if(birthdayElement && !birthdayElement.innerText.includes('birthday')) this.birthdayText = birthdayElement.innerText;
    },

    customActionsPerKeyworkTitle(keyWordTitle){
      // Because LoyaltyLion's response takes a LOT of time, we immediatly show the user the completed
      // and once he reloads the page, he'll see what Loyalty Lion sends
      if(keyWordTitle === 'Pinterest'){
        this.isPinterestCompleted = true;
      }
      if(keyWordTitle === 'TikTok'){
        this.isTiktokCompleted = true;
      }
    },

    updatePoints(){
      if(loyaltylion?.customer){
        this.customerPoints = loyaltylion.customer.pointsTotal;
      }
    },

    redirectToAttentive(){
      window.location = `https://dormify.attn.tv/p/S0f/landing-page`
    }

  },
}
</script>

<style lang="scss">
@import './loyalty-lion-hero';
</style>
